import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text } from "sprout-ui-primitives";
const AppHelpMenuKeyboardShortcut = (props)=>{
    const { label , keybinding: keybindingProps  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        justifyContent: "space-between",
        color: "white.100",
        py: 1,
        px: 2,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                fontWeight: "medium",
                fontSize: "15px",
                children: label
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontWeight: "medium",
                fontSize: "15px",
                children: typeof keybindingProps === "string" ? keybindingProps : keybindingProps.reduce((acc, currentValue, index)=>{
                    if (index === 0) return currentValue;
                    return `${acc} or ${currentValue}`;
                }, "")
            })
        ]
    });
};
export default AppHelpMenuKeyboardShortcut;
